import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldConfirmPassword = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'register-form-confirmPassword',
    defaultMessage: 'Confirm password'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'confirmPassword'});

  return (
    <InputText
      {...field}
      {...meta}
      type={'password'}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldConfirmPassword;
